import { runningEntryUrl } from './appEntry';

export async function logAppVersion() {
    const entryUrl = runningEntryUrl();
    if (!entryUrl) {
        console.log('Versão da aplicação: desenvolvimento local');
        return;
    }

    const version = new URL(entryUrl).pathname.split('/').pop();
    let publishedAt = 'data de publicação indisponível';
    try {
        const response = await fetch(entryUrl, { method: 'HEAD', cache: 'no-store' });
        const modified = response.ok && response.headers.get('Last-Modified');
        if (modified) {
            const date = new Date(modified);
            if (!Number.isNaN(date.getTime())) {
                publishedAt = `${date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })} (Brasília)`;
            }
        }
    } catch (error) {
        console.warn('Não foi possível consultar a data de publicação da aplicação', error);
    }

    console.log(`Versão da aplicação: ${version} | Publicada em: ${publishedAt}`);
}
